export default {
  'common.select.placeholder': 'Vui lòng chọn',
  'common.enabled': 'Bật',
  'common.disabled': 'Tắt',
  'common.select.actStatus.disabled': 'Tắt',
  'common.select.actStatus.enabled': 'Bật',
  'common.select.actStatus.ended': 'Kết thúc',
  'common.select.gameType.slot': 'Slot',
  'common.select.gameType.live': 'Live',
  'common.select.gameType.sport': 'Thể thao',
  'common.select.gameType.lottery': 'Xổ số',
  'common.select.gameType.fish': 'Bắn cá',
  'common.select.gameType.chess': 'Cờ bàn',
  'common.select.gameType.minigame': 'Trò chơi nhỏ',
  'common.select.gameType.xlive': 'Dự đoán',
  'common.select.gameType.esports': 'ESports',
  'common.select.gameType.arcade': 'Arcade',
  'common.select.gameType.bingo': 'Bingo',
  'common.select.gameType.unknown': 'Không xác định',
  'common.select.pointAwardStatus.claimed': 'Đã nhận',
  'common.select.pointAwardStatus.expired': 'Đã hết hạn',
  'common.select.actTemplateType.rebate': 'Hoàn trả cược',
  'common.select.actTemplateType.custom': 'Ưu đãi tùy chỉnh',
  'common.select.actTemplateType.realtimeRebate': 'Hoàn trả game VIP',
  'common.select.actTemplateType.register': 'Thưởng đăng ký',
  'common.select.actTemplateType.dailyFirstRecharge': 'Nạp tiền đầu tiên hàng ngày',
  'common.select.actTemplateType.recharge': 'Thưởng Nạp Tiền',
  'common.select.actTemplateType.loginRecharge': 'Thưởng đăng nhập nạp tiền',
  'common.select.actTemplateType.luckySpin': 'Vòng quay May mắn',
  'common.select.actTemplateType.everyRecharge': 'Thưởng mỗi lần nạp',
  'common.select.actTemplateType.invite': 'Mời bạn bè',
  'common.select.actTemplateType.infoBinding': 'Thưởng ràng buộc thông tin',
  'common.select.actTemplateType.redPacketRain': 'Mưa phong bì',
  'common.select.actTemplateType.firstDeposit': 'Thưởng nạp lần đầu',
  'common.select.actTemplateType.newRebate': 'Hoàn trả cược mới',
  'common.select.manualSendUserStatus.notStarted': 'Chưa bắt đầu',
  'common.select.manualSendUserStatus.processing': 'Đang xử lý',
  'common.select.manualSendUserStatus.success': 'Thành công',
  'common.select.manualSendUserStatus.failed': 'Thất bại',
  'common.select.manualSendStatus.notStarted': 'Chưa bắt đầu',
  'common.select.manualSendStatus.processing': 'Đang xử lý',
  'common.select.manualSendStatus.completed': 'Hoàn thành',
  'common.select.awardType.cash': 'Tiền mặt',
  'common.select.awardType.points': 'Điểm',
  'common.select.actName.vipReward': 'Phần thưởng VIP',
  'common.select.actName.fissionActivity': 'Hoạt động phân tán',
  'common.select.balanceSubType.deposit': 'Nạp tiền',
  'common.select.balanceSubType.withdraw': 'Rút tiền',
  'common.select.balanceSubType.manualSend': 'Gửi thủ công',
  'common.select.balanceSubType.upgradeReward': 'Phần thưởng nâng cấp',
  'common.select.balanceSubType.retentionReward': 'Phần thưởng duy trì',
  'common.select.balanceSubType.weeklySalary': 'Lương hàng tuần',
  'common.select.balanceSubType.monthlySalary': 'Lương hàng tháng',
  'common.select.balanceSubType.birthdayReward': 'Phần thưởng sinh nhật',
  'common.select.balanceSubType.upgradePoint': 'Điểm nâng cấp',
  'common.select.balanceSubType.retentionPoint': 'Điểm duy trì',
  'common.select.balanceSubType.appDayPoint': 'Điểm hàng ngày APP',
  'common.select.balanceSubType.h5DayPoint': 'Điểm hàng ngày H5',
  'common.select.balanceSubType.realtimeRebate': 'Thưởng hoàn trả game VIP',
  'common.select.balanceSubType.rebate': 'Hoàn trả',
  'common.select.balanceSubType.registerBonus': 'Thưởng đăng ký',
  'common.select.balanceSubType.rechargeBonus': 'Thưởng nạp tiền',
  'common.select.balanceSubType.dailyFirstRechargeBonus': 'Thưởng nạp tiền đầu tiên hàng ngày',
  'common.select.balanceSubType.loginRechargeLoginBonus': 'Đăng nhập',
  'common.select.balanceSubType.loginRechargeRechargeBonus': 'Nạp tiền',
  'common.select.balanceSubType.redemptionCodeBonus': 'Thưởng mã đổi',
  'common.select.balanceSubType.luckySpinBonus': 'Thưởng quay may mắn',
  'common.select.balanceSubType.everyRechargeBonus': 'Thưởng mỗi lần nạp',
  'common.select.balanceSubType.inviteBonus': 'Thưởng mời bạn bè',
  'common.select.balanceSubType.inviteAchievementBonus': 'Thưởng thành tích mời bạn bè',
  'common.select.balanceSubType.inviteeBonus': 'Thưởng người mời',
  'common.select.balanceSubType.infoBindingBonus': 'Thưởng ràng buộc thông tin',
  'common.select.balanceSubType.chickTreasureBoxBonus': 'Thưởng Hộp Kho báu',
  'common.select.balanceSubType.chickCheckinBonus': 'Thưởng Điểm danh',
  'common.select.balanceSubType.redPacketRain': 'Mưa phong bì',
  'common.select.balanceSubType.treasureBoxDailyBonus': 'Thưởng Hộp Kho báu ngày',
  'common.select.balanceSubType.newRebateBonus': 'Thưởng hoàn trả mới',
  'common.select.balanceSubType.firstDepositBonus': 'Ưu đãi nạp lần đầu',
  'common.select.balanceSubType.vendorLeaderboardBonus': 'Thưởng hoạt động bảng xếp hạng',
  'common.select.balanceSubType.inviteDepositRebateBonus': 'Hoàn tiền nạp mời bạn',
  'common.select.balanceSubType.inviteBetRebateBonus': 'Hoàn tiền cược mời bạn',
  'common.select.balanceSubType.inviteWinLossRebateBonus': 'Hoàn tiền thắng/thua mời bạn',
  'common.select.balanceSubType.inviteNgrRebateBonus': 'Hoàn tiền NGR mời bạn',
  'common.select.balanceSubType.manualDeposit': 'Nạp tiền thủ công',
  'common.select.balanceSubType.gameTransferIn': 'Chuyển vào game',
  'common.select.balanceSubType.gameTransferOut': 'Chuyển ra game',
  'common.select.balanceSubType.pointExchange': 'Đổi điểm',
  'common.select.balanceSubType.actRechargeFuel': 'Nạp tiền nhiên liệu',
  'common.select.balanceSubType.actInviteFuel': 'Mời bạn bè nhiên liệu',
  'common.select.balanceSubType.actJeepneyEnterReward': 'Thưởng vào trận',
  'common.select.balanceSubType.actJeepneyStageReward': 'Thưởng vượt ải',

  'common.select.balanceSubType.upgradeTicket': 'Vé nâng cấp',
  'common.select.balanceSubType.weeklyTicket': 'Vé hàng tuần',
  'common.select.balanceSubType.monthlyTicket': 'Vé hàng tháng',
  'common.select.balanceSubType.birthdayTicket': 'Vé sinh nhật',
  'common.select.balanceSubType.appDailyTicket': 'Vé hàng ngày APP',
  'common.select.balanceSubType.h5DailyTicket': 'Vé hàng ngày H5',
  'common.select.balanceSubType.weeklyPoint': 'Điểm hàng tuần',
  'common.select.balanceSubType.monthlyPoint': 'Điểm hàng tháng',
  'common.select.balanceSubType.birthdayPoint': 'Điểm sinh nhật',
  'common.select.balanceSubType.retentionTicket': 'Vé duy trì',
  'common.select.balanceSubType.appDailyPoint': 'Điểm hàng ngày APP',
  'common.select.balanceSubType.h5DailyPoint': 'Điểm hàng ngày H5',
};
